// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");

function depthFirst(getChildNodesForNode, initResult, combineNodeWithResult, rootNode) {
  var traverse = function (result, currentNode) {
    return Belt_Array.reduce(Curry._1(getChildNodesForNode, currentNode), Curry._2(combineNodeWithResult, currentNode, result), traverse);
  };
  return traverse(initResult, rootNode);
}

exports.depthFirst = depthFirst;
/* No side effect */
